<template>
  <main class="sales-page">
    <header class="sales-header">
      <div class="sales-container header-inner">
        <a href="#" class="brand" aria-label="Centrallize">
          <img src="../../assets/branding/centrallize-light-mark-clean.png" alt="Símbolo da Centrallize" />
          <span>Centrallize</span>
        </a>

        <nav class="nav-links" aria-label="Navegação principal">
          <!-- <a href="#benefits-section" @click.prevent="scrollToSection('benefits-section')">Solução</a> -->
          <a href="#como-funciona" @click.prevent="scrollToSection('como-funciona')">Como funciona</a>
          <a href="#planos" @click.prevent="scrollToSection('planos')">Planos</a>
        </nav>

        <a href="/login" class="login-link">
          <i class="ph ph-user-circle"></i>
          Entrar
        </a>
      </div>
    </header>

    <section class="hero-section">
      <div class="sales-container hero-grid">
        <div class="hero-content">
          <!-- <a href="#como-funciona" class="video-pill">
            <i class="ph ph-play-fill"></i>
            Veja como o atendimento automático funciona
          </a> -->

          <h1>Automatize o atendimento do seu negócio pelo WhatsApp</h1>
          <p class="hero-copy">
            Organize agenda, clientes, equipe, produtos, estoque e financeiro em uma plataforma que responde, verifica horários e ajuda a transformar mensagens em agendamentos.
          </p>

          <form class="hero-form" @submit.prevent>
            <input v-model.trim="leadEmail" type="email" placeholder="Insira seu e-mail" aria-label="E-mail" />
            <router-link :to="registerEmailRoute()" class="primary-button">
              Começar agora
              <i class="ph ph-arrow-right"></i>
            </router-link>
          </form>

          <span class="microcopy">Teste a plataforma e configure seus primeiros serviços em poucos minutos.</span>

          <div class="trust-row" aria-label="Destaques do produto">
            <div>
              <strong>WhatsApp 24h</strong>
              <span>respostas mesmo fora do expediente</span>
            </div>
            <div>
              <strong>Agenda clara</strong>
              <span>horários por profissional</span>
            </div>
            <div>
              <strong>Gestão completa</strong>
              <span>clientes, vendas e financeiro</span>
            </div>
          </div>
        </div>

        <div class="hero-visual" aria-label="Prévia do sistema Centrallize">
          <div class="dashboard-shell">
            <div class="dashboard-toolbar">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <img src="../../assets/images/home/system77.png" alt="Tela do painel Centrallize" />
          </div>
          <div class="metric-card metric-card--sales">
            <span>Acompanhe os valores do mês, exemplo:</span>
            <strong>R$ 7.184,20</strong>
            <small>Do começo ao final do mês</small>
          </div>
          <div class="floating-card floating-card--top">
            <i class="ph ph-whatsapp-logo"></i>
            <div>
              <strong>WhatsApp automatizado</strong>
              <span>Agendamento 24 horas por dia</span>
            </div>
          </div>
          <div class="floating-card floating-card--bottom">
            <i class="ph ph-chart-line-up"></i>
            <div>
              <strong>Mais horários ocupados</strong>
              <span>Atendimento automático reduz perdas</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <section id="beneficios" class="problem-section">
      <div class="sales-container split-grid space-top-mobile">
        <div>
          <span class="section-label">Solução</span>
          <h2>Uma operação mais bonita para o cliente e mais fácil para a sua equipe.</h2>
        </div>
        <div class="problem-list">
          <article>
            <i class="ph ph-chat-circle-dots"></i>
            <div>
              <h3>O WhatsApp deixa de virar fila</h3>
              <p>O cliente recebe orientação rápida, escolhe serviço e avança para o agendamento com menos espera.</p>
            </div>
          </article>
          <article>
            <i class="ph ph-calendar-x"></i>
            <div>
              <h3>A agenda fica fácil de entender</h3>
              <p>Horários, profissionais e serviços aparecem de forma centralizada, sem depender de anotações soltas.</p>
            </div>
          </article>
          <article>
            <i class="ph ph-currency-circle-dollar"></i>
            <div>
              <h3>Os números entram na rotina</h3>
              <p>Vendas, entradas, despesas e desempenho ficam visíveis para você decidir com mais segurança.</p>
            </div>
          </article>
        </div>
      </div>
    </section> -->

    <!-- <section class="benefits-section">
      <div class="sales-container space-top-mobile">
        <div class="section-heading">
          <span class="section-label">A solução</span>
          <h2>Um sistema criado para salões, barbearias e estética trabalharem com mais controle.</h2>
          <p>Menos trabalho repetitivo, mais organização na operação e uma experiência mais profissional para cada cliente.</p>
        </div>

        <div class="benefits-grid">
          <article v-for="benefit in benefits" :key="benefit.title" class="benefit-card">
            <i :class="benefit.icon"></i>
            <h3>{{ benefit.title }}</h3>
            <p>{{ benefit.description }}</p>
          </article>
        </div>
      </div>
    </section> -->

    <section id="como-funciona" class="workflow-section">
      <div class="sales-container space-top-mobile">
        <div class="workflow-panel">
          <div class="section-heading section-heading--left">
            <span class="section-label">Como funciona</span>
            <h2>Da primeira mensagem ao controle financeiro, tudo conectado.</h2>
          </div>

          <div class="workflow-steps">
            <article v-for="(step, index) in workflowSteps" :key="step.title">
              <span>{{ index + 1 }}</span>
              <h3>{{ step.title }}</h3>
              <p>{{ step.description }}</p>
            </article>
          </div>
        </div>
      </div>
    </section>

    <section class="feature-showcase">
      <div class="sales-container showcase-grid space-top-mobile">
        <div class="showcase-copy">
          <span class="section-label">Gestão completa</span>
          <h2>Você para de adivinhar e passa a enxergar a rotina do negócio.</h2>
          <ul>
            <li v-for="feature in coreFeatures" :key="feature">{{ feature }}</li>
          </ul>
          <a href="#planos" class="primary-button primary-button--dark" @click.prevent="scrollToSection('planos')">
            Quero organizar meu negócio
            <i class="ph ph-arrow-right"></i>
          </a>
        </div>
        <div class="showcase-image">
          <picture>
            <source media="(max-width: 767px)" srcset="../../assets/images/home/mobile2.png" />
            <img src="../../assets/images/home/mobile3.png" alt="Tela de gestão do Centrallize" />
          </picture>
        </div>
      </div>
    </section>

    <section id="planos" class="pricing-section">
      <div class="sales-container space-top-mobile">
        <div class="section-heading">
          <span class="section-label">Planos</span>
          <h2>Comece com uma ferramenta que ajuda a recuperar tempo e oportunidades.</h2>
          <p>Escolha um plano, cadastre seus serviços e deixe o WhatsApp trabalhar junto com sua equipe.</p>
        </div>

        <div v-if="loadingHomePlans" class="pricing-feedback">
          Carregando planos...
        </div>

        <div v-else-if="errorHomePlans" class="pricing-feedback pricing-feedback--error">
          {{ errorHomePlans }}
        </div>

        <div v-else-if="availablePlans.length" class="pricing-grid">
          <article
            v-for="plan in availablePlans"
            :key="plan.id || plan.name"
            class="pricing-card"
            :class="{ 'pricing-card--unavailable': !isPlanAvailable(plan) }"
          >
            <span v-if="!isPlanAvailable(plan)" class="plan-tag plan-tag--unavailable">
              {{ planAvailabilityLabel(plan) }}
            </span>
            <span v-else-if="availablePlans.length == 1" class="plan-tag">PLANO ÚNICO</span>
            <h3>{{ plan.name || plan.title || 'Plano Centrallize' }}</h3>
            <p>{{ formatPlanDescription(plan) }}</p>

            <div class="price">
              <strong>{{ formatPlanPrice(plan) }}</strong>
              <span>{{ formatPlanBillingCycle(plan) }}</span>
            </div>

            <ul v-if="formatPlanFeatures(plan).length">
              <li v-for="(feature, index) in formatPlanFeatures(plan)" :key="index">
                {{ feature }}
              </li>
            </ul>

            <div class="pricing-card__cta">
              <router-link v-if="isPlanAvailable(plan)" :to="registerPlanRoute(plan)" class="pricing-button">
                Escolher plano
                <i class="ph ph-arrow-right"></i>
              </router-link>
              <div v-else class="pricing-button pricing-button--unavailable">
                {{ planAvailabilityLabel(plan) }}
              </div>

              <small v-if="isPlanAvailable(plan)">Sem taxa de setup. Cancele quando quiser.</small>
              <small v-else>Este plano ainda não pode ser contratado.</small>
            </div>
          </article>
        </div>

        <div v-else class="pricing-feedback">
          Nenhum plano disponivel no momento.
        </div>
      </div>
    </section>

    <section class="final-cta">
      <div class="sales-container final-cta-inner space-top-mobile">
        <div>
          <span class="section-label">Próximo passo</span>
          <h2>Seu atendimento pode continuar funcionando enquanto você cuida dos clientes.</h2>
          <p>Coloque agenda, WhatsApp, clientes e financeiro em uma operação simples de acompanhar.</p>
        </div>
        <router-link to="/register" class="primary-button final-cta-button">
          Começar
          <i class="ph ph-arrow-right"></i>
        </router-link>
      </div>
    </section>

    <footer class="sales-footer">
      <div class="sales-container footer-grid">
        <div>
          <a href="#" class="brand brand--footer text-color-footer">
            <img src="../../assets/branding/centrallize-mark-ui.jpg" alt="Símbolo da Centrallize" />
            <span>Centrallize</span>
          </a>
          <p class="text-color-footer">Gestão e automação de atendimento para negócios de beleza, estética e serviços.</p>
        </div>

        <div class="footer-links">
          <a class="text-color-footer" href="/login">Entrar</a>
          <a class="text-color-footer" href="/register">Registrar-se</a>
          <a class="text-color-footer" href="/terms" target="_blank">Termos e Condições</a>
          <a class="text-color-footer" href="/privacy-policy" target="_blank">Política de privacidade</a>
        </div>

        <div class="footer-contact">
          <span class="text-color-footer">Contato:</span>
          <a class="text-color-footer" href="mailto:contato@sanvault.com.br">contato@sanvault.com.br</a>
          <a class="text-color-footer" href="https://www.linkedin.com/company/sanvault-tecnologia/" target="_blank">LinkedIn</a>
        </div>
      </div>
      <div class="sales-container copyright text-color-footer">
        (c) 2026 Centrallize. Todos os direitos reservados.
      </div>
    </footer>
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import api from "../../config/axios.js";

export default defineComponent({
  name: "HomePage",
  data() {
    return {
      quantidade: 0,
      tamanhoMedio: 0,
      valorFinal: "0,00",
      homePlans: [],
      loadingHomePlans: true,
      errorHomePlans: "",
      leadEmail: "",
      benefits: [
        {
          icon: "ph ph-clock-afternoon",
          title: "Atendimento 24h",
          description: "Clientes conseguem consultar horários e solicitar agendamento mesmo fora do expediente.",
        },
        {
          icon: "ph ph-whatsapp-logo",
          title: "WhatsApp automatizado",
          description: "O canal que seus clientes já usam vira uma rotina organizada de agendamentos.",
        },
        {
          icon: "ph ph-calendar-check",
          title: "Agenda por profissional",
          description: "Visualize disponibilidade, serviços e horários sem conflito entre atendentes.",
        },
        {
          icon: "ph ph-users-three",
          title: "Clientes centralizados",
          description: "Histórico, contatos e atendimentos ficam reunidos para sua equipe vender melhor.",
        },
        {
          icon: "ph ph-chart-line-up",
          title: "Métricas de crescimento",
          description: "Acompanhe vendas, atendimentos e desempenho para tomar decisões com dados.",
        },
        {
          icon: "ph ph-wallet",
          title: "Financeiro no controle",
          description: "Organize entradas, despesas e faturamento sem depender de controles paralelos.",
        },
      ],
      workflowSteps: [
        {
          title: "Configure serviços e equipe",
          description: "Cadastre duração, disponibilidade e profissionais de cada atendimento.",
        },
        {
          title: "Conecte o atendimento",
          description: "O WhatsApp passa a responder, orientar e encaminhar agendamentos automaticamente.",
        },
        {
          title: "Acompanhe tudo no painel",
          description: "Veja agenda, clientes, conversas, vendas e financeiro em uma única operação.",
        },
      ],
      coreFeatures: [
        "Dashboard para acompanhar agendamentos, vendas e desempenho",
        "Calendário com horários, clientes e disponibilidade em tempo real",
        "Gestão de serviços com durações diferentes",
        "Histórico de conversas e atendimentos centralizado",
        "Busca rápida de clientes, profissionais e horários",
        "Atendimento padronizado para toda a equipe",
      ],
    };
  },
  methods: {
    ...mapActions(["setServicePrice", "setGbFree"]),
    scrollToSection(sectionId) {
      const section = document.getElementById(sectionId);

      if (!section) {
        return;
      }

      const headerOffset = 86;
      const sectionPosition = section.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: Math.max(sectionPosition - headerOffset, 0),
        behavior: "smooth",
      });
    },
    async fetchHomePlans() {
      this.loadingHomePlans = true;
      this.errorHomePlans = "";

      await api.axios
        .get("/api/plans")
        .catch(() => {
          this.errorHomePlans = "Não foi possível buscar os planos agora. Tente novamente mais tarde.";
          this.homePlans = [];
        })
        .then((response) => {
          if (response && response.status === 200) {
            this.homePlans = response.data;
          }
        });

      this.loadingHomePlans = false;
    },
    formattedValue(value) {
      const numero = parseFloat(value);
      return numero.toFixed(2).replace(".", ",");
    },
    formatPlanDescription(plan) {
      if (!plan) {
        return "";
      }

      return (
        plan.description ||
        plan.short_description ||
        plan.subtitle ||
        plan.resume ||
        plan.summary ||
        "Plano para automatizar atendimento, organizar agenda e acompanhar o crescimento do seu negócio."
      );
    },
    formatPlanPrice(plan) {
      if (!plan) {
        return "Indisponível";
      }

      if (plan.price_formatted) {
        return plan.price_formatted.indexOf("R$") === 0 ? plan.price_formatted : `R$ ${plan.price_formatted}`;
      }

      if (plan.value_formatted) {
        return plan.value_formatted.indexOf("R$") === 0 ? plan.value_formatted : `R$ ${plan.value_formatted}`;
      }

      const rawValue = plan.price || plan.value || plan.amount;

      if (rawValue === undefined || rawValue === null || rawValue === "") {
        return "Indisponível";
      }

      const numericValue = Number(rawValue);

      if (Number.isNaN(numericValue)) {
        return `R$ ${String(rawValue).replace(".", ",")}`;
      }

      return numericValue.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    formatPlanBillingCycle(plan) {
      if (!plan) {
        return "";
      }

      const cycle = plan.billing_cycle || plan.interval || plan.period || plan.recurrence;
      const cycleLabels = {
        month: "/mês",
        monthly: "/mês",
        mes: "/mês",
        year: "/ano",
        yearly: "/ano",
        ano: "/ano",
      };

      return cycleLabels[cycle] || cycle || "/mês";
    },
    formatPlanFeatures(plan) {
      const features = plan && (plan.features || plan.benefits);

      if (Array.isArray(features) && features.length) {
        return features
          .map((feature) => {
            if (typeof feature === "string") {
              return feature;
            }

            return feature.name || feature.description || "";
          })
          .filter(Boolean);
      }

      return [];
    },
    isPlanAvailable(plan) {
      return !!plan && plan.available_for_purchase !== false;
    },
    planAvailabilityLabel(plan) {
      return plan && plan.availability_status === "maintenance"
        ? "EM MANUTENÇÃO"
        : "EM BREVE";
    },
    registerPlanRoute(plan) {
      if (!plan || !plan.id) {
        return "/register";
      }

      return {
        path: "/register",
        query: {
          plan_id: plan.id,
        },
      };
    },
    registerEmailRoute() {
      if (!this.leadEmail) {
        return "/register";
      }

      return {
        path: "/register",
        query: {
          email: this.leadEmail,
        },
      };
    },
    calcularValorFinal() {
      const totalGB = (this.quantidade * this.tamanhoMedio) / 1024;
      const totalCurrentPrice = totalGB * this.getServicePrice;
      const valorFinalSemArredondar = Math.floor(totalCurrentPrice * 100) / 100;

      this.valorFinal = new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(valorFinalSemArredondar);
    },
  },
  mounted() {
    this.setServicePrice();
    this.setGbFree();
    this.fetchHomePlans();
  },
  computed: {
    ...mapGetters(["getServicePrice", "getGbFree"]),
    availablePlans() {
      const payload = (this as any).homePlans;

      if (!payload) {
        return [];
      }

      if (Array.isArray(payload)) {
        return payload;
      }

      if (Array.isArray(payload.data)) {
        return payload.data;
      }

      if (Array.isArray(payload.plans)) {
        return payload.plans;
      }

      return [];
    },
  },
});
</script>

<style scoped>
.sales-page {
  background: #ffffff;
  color: #252525;
  overflow-x: hidden;
}

.sales-container {
  margin: 0 auto;
  max-width: 1180px;
  padding: 0 24px;
  width: 100%;
}

.sales-header {
  backdrop-filter: blur(22px);
  background: rgba(255, 255, 255, 0.78);
  border-bottom: 1px solid rgba(255, 255, 255, 0.42);
  left: 0;
  position: sticky;
  right: 0;
  top: 0;
  z-index: 20;
}

.header-inner {
  align-items: center;
  display: flex;
  gap: 28px;
  height: 78px;
  justify-content: space-between;
}

.brand {
  align-items: center;
  color: #151515;
  display: inline-flex;
  font-size: 20px;
  font-weight: 700;
  gap: 10px;
  text-decoration: none;
  white-space: nowrap;
}

.brand img {
  height: 42px;
  object-fit: cover;
  width: 42px;
}

.nav-links {
  align-items: center;
  display: flex;
  gap: 28px;
}

.nav-links a,
.footer-links a,
.footer-contact a {
  color: #55545b;
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
}

.nav-links a:hover,
.footer-links a:hover,
.footer-contact a:hover {
  color: #007f5f;
}

.login-link {
  align-items: center;
  background: var(--splash-primary-color, #6560f0);
  border-radius: 7px;
  box-shadow: 0 10px 22px rgba(101, 96, 240, 0.18);
  color: #ffffff;
  display: inline-flex;
  font-weight: 700;
  gap: 8px;
  min-height: 44px;
  padding: 0 18px;
  text-decoration: none;
}

.login-link:hover {
  background: var(--splash-primary-active-color, #726eed);
  box-shadow: 0 12px 26px rgba(101, 96, 240, 0.22);
  color: #ffffff;
}

.hero-section {
  background:
    linear-gradient(rgba(37, 86, 96, 0.055) 1px, transparent 1px),
    linear-gradient(90deg, rgba(37, 86, 96, 0.055) 1px, transparent 1px),
    radial-gradient(circle at 78% 24%, rgba(56, 157, 255, 0.26), transparent 30%),
    radial-gradient(circle at 42% 25%, rgba(84, 242, 172, 0.35), transparent 34%),
    linear-gradient(135deg, #f8fff9 0%, #b8f6d1 44%, #9fc9ff 100%);
  background-size: 42px 42px, 42px 42px, auto, auto, auto;
  min-height: calc(100vh - 78px);
  overflow: hidden;
  padding: 92px 0 120px;
  position: relative;
}

.hero-grid,
.split-grid,
.showcase-grid,
.footer-grid {
  align-items: center;
  display: grid;
  gap: 56px;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
}

.hero-grid {
  align-items: start;
  grid-template-columns: minmax(0, 0.82fr) minmax(0, 1.18fr);
}

.hero-content {
  position: relative;
  z-index: 2;
}

.video-pill {
  align-items: center;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(101, 96, 240, 0.18);
  border-radius: 7px;
  color: var(--splash-primary-color, #6560f0);
  display: inline-flex;
  font-size: 17px;
  font-weight: 600;
  gap: 12px;
  min-height: 56px;
  padding: 0 24px;
  text-decoration: none;
}

.video-pill i {
  color: var(--splash-primary-color, #6560f0);
  font-size: 17px;
}

.eyebrow,
.section-label,
.plan-tag {
  color: #007f5f;
  display: inline-block;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0;
  margin-bottom: 14px;
  text-transform: uppercase;
}

.hero-content h1,
.section-heading h2,
.split-grid h2,
.showcase-copy h2,
.final-cta h2 {
  color: #202020;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.12;
}

.hero-content h1 {
  color: #050607;
  font-size: 64px;
  letter-spacing: -1px;
  line-height: 1.04;
  margin: 62px 0 24px;
}

.hero-copy {
  color: #1f2a2d;
  font-size: 21px;
  line-height: 1.6;
  margin: 0 0 36px;
  max-width: 650px;
}

.hero-form {
  align-items: center;
  background: #ffffff;
  border: 1px solid rgba(16, 19, 20, 0.12);
  border-radius: 7px;
  box-shadow: 0 24px 58px rgba(24, 51, 55, 0.12);
  display: flex;
  gap: 8px;
  max-width: 680px;
  padding: 8px;
}

.hero-form input {
  background: transparent;
  border: 0;
  border-radius: 7px;
  color: #101314;
  flex: 1;
  font-size: 18px;
  min-height: 56px;
  min-width: 0;
  outline: 0;
  padding: 0 24px;
}

.hero-form input::placeholder {
  color: #8b9298;
}

.microcopy {
  color: rgba(31, 42, 45, 0.72);
  display: block;
  font-size: 14px;
  margin: 18px 0 34px;
}

.primary-button,
.secondary-button,
.pricing-button {
  align-items: center;
  border-radius: 7px;
  display: inline-flex;
  font-weight: 700;
  gap: 10px;
  justify-content: center;
  min-height: 56px;
  padding: 0 28px;
  text-decoration: none;
}

.primary-button,
.pricing-button {
  background: #06b48a;
  color: #ffffff;
  box-shadow: 0 12px 24px rgba(6, 180, 138, 0.18);
}

.primary-button:hover,
.pricing-button:hover {
  background: #049c76;
  box-shadow: 0 14px 28px rgba(6, 180, 138, 0.22);
  color: #ffffff;
}

.secondary-button {
  background: #ffffff;
  border: 1px solid rgba(23, 23, 23, 0.12);
  color: #171717;
}

.trust-row {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  max-width: 620px;
}

.trust-row div {
  /* background: rgba(255, 255, 255, 0.72); */
  background: #fff;
  border: 1px solid rgba(23, 23, 23, 0.08);
  border-radius: 8px;
  padding: 16px;
}

.trust-row strong,
.trust-row span {
  display: block;
}

.trust-row strong {
  color: #2a2a2a;
  font-size: 20px;
  font-weight: 700;
}

.trust-row span {
  color: #52525b;
  font-size: 13px;
  margin-top: 4px;
}

.hero-visual {
  min-height: 690px;
  position: relative;
}

.dashboard-shell,
.showcase-image {
  background: #ffffff;
  border: 1px solid rgba(23, 23, 23, 0.08);
  border-radius: 28px;
  box-shadow: 0 38px 92px rgba(21, 41, 48, 0.2);
}

.dashboard-shell {
  background: transparent;
  border: 0;
  box-shadow: none;
  left: 0;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 118px;
  transform: none;
  width: clamp(760px, 64vw, 1050px);
}

.dashboard-shell::before {
  display: none;
}

.dashboard-toolbar {
  display: none;
}

.dashboard-toolbar span {
  background: #ffffff;
  border-radius: 50%;
  display: block;
  height: 9px;
  opacity: 0.7;
  width: 9px;
}

.dashboard-shell img,
.showcase-image picture,
.showcase-image img {
  display: block;
  height: auto;
  width: 100%;
}

.dashboard-shell img {
  /* border: 1px solid rgba(23, 23, 23, 0.08); */
  border-radius: 8px;
  /* box-shadow: 0 26px 70px rgba(20, 32, 42, 0.24); */
  margin-top: 0;
  position: relative;
  z-index: 1;
}

.floating-card {
  align-items: center;
  background: #ffffff;
  border: 1px solid rgba(23, 23, 23, 0.08);
  border-radius: 7px;
  box-shadow: 0 20px 54px rgba(21, 41, 48, 0.15);
  display: flex;
  gap: 14px;
  max-width: 330px;
  padding: 18px;
  position: absolute;
}

.floating-card i {
  align-items: center;
  background: #e8fff7;
  border-radius: 16px;
  color: #087a5a;
  display: flex;
  flex: 0 0 44px;
  font-size: 24px;
  height: 44px;
  justify-content: center;
}

.floating-card strong,
.floating-card span {
  display: block;
}

.floating-card strong {
  font-size: 15px;
  font-weight: 700;
}

.floating-card span {
  color: #52525b;
  font-size: 13px;
  margin-top: 3px;
}

.floating-card--top {
  right: 0;
  top: 98px;
  z-index: 3;
}

.floating-card--bottom {
  bottom: 74px;
  left: -32px;
  z-index: 3;
}

.metric-card {
  background: #101314;
  border-radius: 7px;
  box-shadow: 0 28px 62px rgba(21, 41, 48, 0.2);
  color: #ffffff;
  padding: 26px 28px;
  position: absolute;
  right: 8px;
  top: 478px;
  width: 310px;
  z-index: 2;
}

.metric-card span,
.metric-card small {
  color: rgba(255, 255, 255, 0.7);
  display: block;
}

.metric-card strong {
  display: block;
  font-size: 36px;
  line-height: 1;
  margin: 10px 0 12px;
}

.metric-card small {
  color: #74f0a0;
  font-size: 15px;
}

.problem-section,
.benefits-section,
.workflow-section,
.feature-showcase,
.pricing-section,
.final-cta,
.sales-footer {
  padding: 82px 0;
}

.problem-section,
.feature-showcase {
  background: #ffffff;
}

.feature-showcase {
  overflow: hidden;
}

.split-grid {
  align-items: start;
}

.split-grid h2,
.section-heading h2,
.showcase-copy h2,
.final-cta h2 {
  font-size: 36px;
  margin: 0;
}

.problem-list {
  display: grid;
  gap: 18px;
}

.problem-list article {
  align-items: flex-start;
  background: #fbfaf7;
  border: 1px solid rgba(23, 23, 23, 0.08);
  border-radius: 8px;
  display: flex;
  gap: 16px;
  padding: 22px;
}

.problem-list i,
.benefit-card i {
  color: #06b48a;
  font-size: 30px;
}

.problem-list h3,
.benefit-card h3,
.workflow-steps h3,
.pricing-card h3 {
  color: #242424;
  font-size: 19px;
  font-weight: 700;
  margin: 0 0 8px;
}

.problem-list p,
.benefit-card p,
.workflow-steps p,
.section-heading p,
.showcase-copy li,
.pricing-card p,
.pricing-card li,
.final-cta p,
.sales-footer p {
  color: #5e5c64;
  font-size: 16px;
  line-height: 1.6;
  margin: 0;
}

.section-heading {
  margin: 0 auto 44px;
  max-width: 760px;
  text-align: center;
}

.section-heading p {
  margin-top: 16px;
}

.section-heading--left {
  margin-left: 0;
  text-align: left;
}

.benefits-grid {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.benefit-card {
  background: #ffffff;
  border: 1px solid rgba(23, 23, 23, 0.08);
  border-radius: 8px;
  min-height: 230px;
  padding: 28px;
}

.benefit-card h3 {
  margin-top: 20px;
}

.workflow-section {
  background: #eef7f2;
}

.workflow-panel h2,
.workflow-panel .section-label {
  color: #202020;
}

.workflow-steps {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 34px;
}

.workflow-steps article {
  background: #ffffff;
  border: 1px solid rgba(23, 23, 23, 0.08);
  border-radius: 8px;
  min-height: 230px;
  padding: 28px;
}

.workflow-steps span {
  align-items: center;
  background: #178a68;
  border-radius: 50%;
  color: #ffffff;
  display: flex;
  font-weight: 700;
  height: 42px;
  justify-content: center;
  margin-bottom: 22px;
  width: 42px;
}

.workflow-steps h3 {
  color: #242424;
}

.workflow-steps p {
  color: #5e5c64;
}

.showcase-grid {
  align-items: center;
  grid-template-columns: minmax(0, 0.82fr) minmax(0, 1.18fr);
}

.showcase-image{
  height: 633px;
}

.showcase-image {
  background:
    radial-gradient(circle at 18% 22%, rgba(6, 180, 138, 0.18), transparent 32%),
    radial-gradient(circle at 82% 78%, rgba(101, 96, 240, 0.12), transparent 34%),
    linear-gradient(135deg, #f8fffb 0%, #edf8f4 100%);
  border-color: rgba(6, 180, 138, 0.12);
  border-radius: 8px;
  box-shadow: 0 26px 70px rgba(21, 41, 48, 0.1);
  min-height: 500px;
  overflow: hidden;
  padding: 0;
  position: relative;
}

/* .showcase-image::before {
  background: linear-gradient(90deg, rgba(6, 180, 138, 0.3), rgba(101, 96, 240, 0.18));
  content: "";
  height: 5px;
  left: 34px;
  position: absolute;
  right: 34px;
  top: 30px;
  z-index: 1;
} */

.showcase-image img {
  filter: drop-shadow(0 28px 46px rgba(21, 41, 48, 0.18));
  /* max-width: none; */
  /* position: absolute; */
  /* right: -18%; */
  /* top: 52%; */
  /* transform: translateY(-50%) scale(1.08); */
  width: 118%;
}

.showcase-copy ul,
.pricing-card ul {
  list-style: none;
  margin: 24px 0 28px;
  padding: 0;
}

.showcase-copy li,
.pricing-card li {
  margin-bottom: 12px;
  padding-left: 28px;
  position: relative;
}

.showcase-copy li::before,
.pricing-card li::before {
  background: #06b48a;
  border-radius: 50%;
  content: "";
  height: 8px;
  left: 0;
  position: absolute;
  top: 9px;
  width: 8px;
}

.primary-button--dark {
  background: #06b48a;
  border-radius: 7px;
  box-shadow: 0 12px 24px rgba(6, 180, 138, 0.18);
}

.primary-button--dark:hover {
  background: #049c76;
  box-shadow: 0 14px 28px rgba(6, 180, 138, 0.22);
}

.pricing-section {
  background:
    radial-gradient(circle at 90% 20%, rgba(94, 176, 144, 0.1), transparent 24%),
    #f7f8f5;
}

.pricing-grid {
  align-items: stretch;
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(auto-fit, minmax(280px, 360px));
  justify-content: center;
}

.pricing-card,
.pricing-feedback {
  background: #ffffff;
  border: 1px solid rgba(23, 23, 23, 0.08);
  border-radius: 8px;
  box-shadow: 0 18px 44px rgba(23, 23, 23, 0.06);
  padding: 32px;
}

.pricing-card {
  display: flex;
  flex-direction: column;
}

.pricing-card--unavailable {
  background: #fafafa;
}

.pricing-card--single,
.pricing-feedback {
  margin: 0 auto;
  max-width: 380px;
}

.pricing-feedback {
  color: #52525b;
  text-align: center;
}

.pricing-feedback--error {
  background: #fff5f5;
  border-color: rgba(220, 53, 69, 0.24);
  color: #b02a37;
}

.price {
  align-items: baseline;
  display: flex;
  gap: 8px;
  margin: 20px 0 8px;
}

.price strong {
  color: #178a68;
  font-size: 38px;
  font-weight: 700;
  line-height: 1;
}

.price span,
.pricing-card small {
  color: #71717a;
}

.pricing-button {
  background: #06b48a;
  border-radius: 7px;
  box-shadow: 0 12px 24px rgba(6, 180, 138, 0.18);
  width: 100%;
}

.pricing-button:hover {
  background: #049c76;
  box-shadow: 0 14px 28px rgba(6, 180, 138, 0.22);
}

.pricing-button--unavailable {
  background: #e5e7eb;
  box-shadow: none;
  color: #6b7280;
  cursor: default;
  text-align: center;
}

.pricing-button--unavailable:hover {
  background: #e5e7eb;
  box-shadow: none;
}

.plan-tag--unavailable {
  background: #fff4d6;
  color: #8a5a00;
}

.pricing-card small {
  display: block;
  font-size: 13px;
  margin-top: 16px;
  text-align: center;
}

.pricing-card__cta {
  margin-top: auto;
}

.final-cta {
  background: #ffffff;
}

.final-cta-inner {
  align-items: center;
  background: #eef7f2;
  border-radius: 7px;
  display: flex;
  gap: 32px;
  justify-content: space-between;
  padding: 44px;
}

.final-cta h2,
.final-cta p,
.final-cta .section-label {
  color: #202020;
}

.final-cta p {
  color: #5e5c64;
  margin-top: 12px;
}

.final-cta-button {
  background: #06b48a;
  border-radius: 7px;
  box-shadow: 0 12px 24px rgba(6, 180, 138, 0.22);
  color: #ffffff;
  flex: 0 0 auto;
  min-height: 48px;
  min-width: 148px;
  padding: 0 22px;
  white-space: nowrap;
}

.final-cta-button:hover {
  background: #049c76;
  box-shadow: 0 14px 28px rgba(6, 180, 138, 0.28);
  color: #ffffff;
}

.final-cta-button i {
  font-size: 1.1rem;
}

.sales-footer {
  background: #2B2A3F;
  padding-bottom: 34px;
  color: #fff;
}

.footer-grid {
  align-items: start;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 0.8fr) minmax(0, 0.8fr);
}

.brand--footer {
  margin-bottom: 14px;
}

.footer-links,
.footer-contact {
  display: grid;
  gap: 12px;
}

.footer-contact span {
  color: #171717;
  font-weight: 700;
}

.copyright {
  border-top: 1px solid rgba(23, 23, 23, 0.08);
  font-size: 14px;
  margin-top: 46px;
  padding-top: 24px;
}

@media (max-width: 991px) {
  .hero-grid,
  .split-grid,
  .showcase-grid,
  .footer-grid {
    grid-template-columns: 1fr;
  }

  .hero-content h1 {
    font-size: 48px;
    margin-top: 38px;
  }

  .benefits-grid,
  .workflow-steps {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .hero-visual {
    min-height: auto;
  }

  .dashboard-shell {
    left: auto;
    margin: 0;
    position: relative;
    top: auto;
    transform: none;
    width: 100%;
  }

  .showcase-image {
    min-height: 420px;
  }

  .showcase-image img {
    right: -22%;
    width: 124%;
  }

  .floating-card {
    margin-top: 14px;
    max-width: none;
    position: static;
  }

  .metric-card {
    margin-top: 14px;
    position: static;
    width: auto;
  }

  .final-cta-inner {
    align-items: flex-start;
    flex-direction: column;
  }
}

@media (max-width: 767px) {
  .sales-container {
    padding: 0 18px;
  }

  .header-inner {
    gap: 14px;
    height: 70px;
  }

  .nav-links {
    display: none;
  }

  .brand span {
    font-size: 17px;
  }

  .login-link {
    min-height: 40px;
    padding: 0 14px;
  }

  .hero-section,
  .problem-section,
  .benefits-section,
  .workflow-section,
  .feature-showcase,
  .pricing-section,
  .final-cta,
  .sales-footer {
    padding: 10px 0;
  }

  .hero-content h1 {
    font-size: 39px;
  }

  .hero-copy {
    font-size: 18px;
  }

  .video-pill {
    font-size: 15px;
    min-height: 48px;
    padding: 0 16px;
  }

  .hero-form {
    align-items: stretch;
    border-radius: 7px;
    flex-direction: column;
    padding: 10px;
  }

  .hero-form input {
    min-height: 52px;
    padding: 0 14px;
  }

  .hero-form .primary-button {
    border-radius: 7px;
    width: 100%;
  }

  .pricing-grid {
    grid-template-columns: 1fr;
  }

  .pricing-button {
    width: 100%;
  }

  .trust-row,
  .benefits-grid,
  .workflow-steps {
    grid-template-columns: 1fr;
  }

  .split-grid h2,
  .section-heading h2,
  .showcase-copy h2,
  .final-cta h2 {
    font-size: 31px;
  }

  .dashboard-shell,
  .showcase-image,
  .final-cta-inner {
    border-radius: 12px;
  }

  .showcase-image {
    min-height: 320px;
  }

  .showcase-image::before {
    left: 22px;
    right: 22px;
    top: 20px;
  }

  .showcase-image img {
    right: -30%;
    width: 138%;
  }

  .final-cta-inner {
    padding: 30px 22px;
  }

  .price strong {
    font-size: 34px;
  }
}

.text-color-footer{
  color: #c3c3c6 !important;
}

.space-top-mobile{
  padding-top: 45px !important;
}
</style>
